export default "__VITE_ASSET__CJkeZEHs__"